exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qr-scrollable-tabs {\n  display: -ms-flexbox;\n  display: flex;\n  overflow-x: auto;\n  border-bottom: 1px solid #e6e8ea;\n  -webkit-overflow-scrolling: touch;\n}\n\n.qr-scrollable-tabs::-webkit-scrollbar {\n  display: none;\n}\n\n.qr-tab-item {\n  padding: 12px 16px;\n  font-size: 14px;\n  color: #526069;\n  cursor: pointer;\n  white-space: nowrap;\n  border-bottom: 2px solid transparent;\n  transition: all 0.2s ease;\n}\n\n.qr-tab-item:hover {\n  color: #37474f;\n  background-color: #f9f9f9;\n}\n\n.qr-tab-item.active {\n  color: #007bff;\n  border-bottom: 2px solid #007bff;\n  font-weight: 500;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/status-filter/status-filter.component.css
// module id = ../../../../../src/app/components/status-filter/status-filter.component.css
// module chunks = 3